import { FC } from "react";
import styles from "./SourcePill.module.css";
import { Search as DeepDiveIcon } from "@mui/icons-material";
import { Osdk } from "@osdk/client";
import { Analysis } from "@unruly-osdk/sdk";
import { useEventDeepDive } from "../../hooks/useEventDeepDive";

interface DeepDiveButtonProps {
  eventId: string;
  eventName?: string;
  sourceUrl?: string;
  userId?: string;
  onOpenAnalysis?: (analysis: Osdk.Instance<Analysis>, eventId: string) => void;
}

export const DeepDiveButton: FC<DeepDiveButtonProps> = ({
  eventId,
  eventName,
  sourceUrl,
  userId,
  onOpenAnalysis,
}) => {
  const { status, isLoading, handleRequestDeepDive, handleOpenDeepDive } =
    useEventDeepDive({ eventId, eventName, sourceUrl, userId, onOpenAnalysis });

  return (
    <div className={styles.tooltipButton}>
      {status === "failed" ? (
        <button
          onClick={handleRequestDeepDive}
          disabled={isLoading}
          className={styles.actionButton}
        >
          <div className={styles.actionIcon}>
            <DeepDiveIcon fontSize="small" />
          </div>
          <span className={styles.actionLabel}>
            {isLoading ? "Retrying..." : "Deep-Dive"}
          </span>
        </button>
      ) : status === "completed" ? (
        <button onClick={handleOpenDeepDive} className={styles.actionButton}>
          <div className={styles.actionIcon}>
            <DeepDiveIcon fontSize="small" />
          </div>
          <span className={styles.actionLabel}>Deep-Dive</span>
        </button>
      ) : (
        <button
          onClick={handleRequestDeepDive}
          disabled={isLoading || status !== "idle"}
          className={styles.actionButton}
        >
          <div className={styles.actionIcon}>
            <DeepDiveIcon fontSize="small" />
          </div>
          <span className={styles.actionLabel}>
            {isLoading
              ? "Creating..."
              : status === "requested"
                ? "Deep-Dive (Requested)"
                : status === "processing"
                  ? "Deep-Dive (Processing)"
                  : "Deep-Dive"}
          </span>
        </button>
      )}
    </div>
  );
};
